var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlFilledThirteen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9225 4.45312H19.9845C18.6364 1.72906 15.8827 0 12.8125 0C8.39245 0 4.79688 3.59557 4.79688 8.01562C4.79688 12.4357 8.39245 16.0312 12.8125 16.0312C15.8827 16.0312 18.6364 14.3022 19.9845 11.5781H22.0875L23.5 10.1657L24.9125 11.5781H27.4313L28.8438 10.1657L30.5415 11.8634L35.1969 8.01562L30.9225 4.45312ZM12.8125 10.6875C11.3392 10.6875 10.1406 9.48896 10.1406 8.01562C10.1406 6.54229 11.3392 5.34375 12.8125 5.34375C14.2858 5.34375 15.4844 6.54229 15.4844 8.01562C15.4844 9.48896 14.2858 10.6875 12.8125 10.6875Z",
    fill: "#D2AE5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.3398H4.6875V38.4023H0V24.3398Z",
    fill: "#D2AE5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0195 20.874C36.2815 20.0142 34.1798 20.7201 33.3129 22.4519L28.8483 31.3705H14.0625V29.0267C14.4258 29.0267 28.672 29.0267 28.125 29.0267C28.125 26.4378 26.0263 24.3392 23.4375 24.3392C23.179 24.3392 17.7093 24.3392 18.0451 24.3392C14.9667 21.5658 10.5055 21.2117 7.03125 23.2008V36.3154H31.6131L39.0747 21.3957L38.0195 20.874Z",
    fill: "#D2AE5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlFilledThirteen);
export default __webpack_public_path__ + "static/media/al-filled-thirteen.3eeeb4e890bf1218ed754025e4028015.svg";
export { ForwardRef as ReactComponent };